module.exports = __webpack_public_path__ + "static/media/Purplewoman.1343b9f4.jpg";